import React, { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { hasPermission } from '../../auth/permissions';
import { getAlertSummary } from '../../api/alertsApi';
import './security.css';

const items = [
  ['/security', 'Overview', 'ivt.read'],
  ['/security/threats', 'Threats', 'ivt.read'],
  ['/security/rules', 'Block / Allow lists', 'rules.read'],
  ['/security/settings', 'Protection settings', 'protection.read'],
  ['/security/alerts', 'Alerts', 'alerts.read'],
  ['/analytics', 'Traffic analytics', 'analytics.read'],
  ['/modules', 'All modules', 'ivt.read'],
];

export default function SecurityNav() {
  const [open, setOpen] = useState(0);
  useEffect(() => {
    if (!hasPermission('alerts.read')) return;
    getAlertSummary().then((d) => setOpen(d.open)).catch(() => {});
  }, []);
  return (
    <nav className="sec-nav">
      <Link to="/">← Dashboard</Link>
      {items.filter(([, , p]) => hasPermission(p)).map(([to, label]) => (
        <NavLink key={to} to={to} end className={({ isActive }) => (isActive ? 'active' : '')}>{label}{to === '/security/alerts' && open > 0 ? ` (${open})` : ''}</NavLink>
      ))}
    </nav>
  );
}
